// extracted by mini-css-extract-plugin
export default {"form":"AddProfile_form__vO1v0","spacing":"AddProfile_spacing__Awsy+","widthHalfPage":"AddProfile_widthHalfPage__o2CH+"};